module.exports = __webpack_public_path__ + "img/aboutUs-header-img02_ja.7cd44b1a.png";